import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'millionsFormat',
})
export class MillionsFormatPipeService implements PipeTransform {
  transform(num: number): string {
    if (num >= 1_000_000 && num != 0) {
      return (num / 1_000_000).toFixed(1) + 'M';
    } else if (num >= 1_000) {
      return (num / 1_000_000).toFixed(3) + 'M';
    } else if (num == 0) {
      return '0M';
    } else {
      return 'S/Info';
    }
  }
}